<style lang="less" scoped>

  @bg_color: #ffffff;
  @bg_color_footer: #414141;
  @color_footer: #ffffff;

  .container {
    width: 100%;
    background-color: @bg_color;
  }
  .logo {
    height: 154px;
    background-repeat: no-repeat;
    background-position: center left;
  }
  .search-bar {
    text-align: right;
    margin-top: 70px;
    &:before {
      content: ' ';
      display: inline-block;
      width:1px;
      height:100%;
      vertical-align: middle;
    }
  }
  .search-bar-input {
    position: relative;
    top: 0;
    width: 300px;
  }
  .search-bar-input  /deep/ input {
    padding: 5px 0;
    border: none;
    line-height: 24px;
    height: 24px;
    border-radius: 0;
    border-bottom: 2px solid #004da0;
    &:focus {
      outline: none;
    }
  }
  .search-bar-item {
    margin-left: 5px;
  }
  .search-bar-icon {
    font-size: 30px;
    color: #084A95;
    vertical-align: middle !important;
    cursor: pointer;
  }
  .main {
    padding: 0;
  }
  .footer {
    color: @color_footer;
    a {
      color: @color_footer;
    }
    padding: 40px 200px;
    background-color: @bg_color_footer;
  }

  .footer-title {
    font-size: 18px;
  }

  .footer-link, .footer-title {
    line-height: 2;
    margin-left: 30px;
    position: relative;
  }

  .footer-icon {
    position: absolute;
    left: -30px;
    top: 8px;
  }
  .icon-shipping {
    top: 2px;
    left: -40px;
    font-size: 28px;
  }
</style>

<template>
  <el-container class="container">
    <el-header class="header container-fixed" height="auto">
      <el-row>
        <el-col :span="12" class="logo" :style="`background-image: url('${logoUrl}')`">
        </el-col>
        <el-col :span="12" class="search-bar">
          <el-input v-model="keyword" class="search-bar-input search-bar-item" type="text"
                    @keyup.enter.native="handleSearch"
                    placeholder="输入商品名称/型号搜索" />
          <svg-icon class="search-bar-item search-bar-icon" icon-class="search" @click.native="handleSearch" />
          <el-badge :value="cartNum" class="item" type="warning">
            <router-link :to="{name: 'cart-index'}">
              <svg-icon class="search-bar-item search-bar-icon" icon-class="cart" />
            </router-link>
          </el-badge>
          <router-link :to="{name: 'member-index'}">
            <svg-icon class="search-bar-item search-bar-icon" icon-class="people" />
          </router-link>
        </el-col>
      </el-row>
    </el-header>
    <el-main class="main">
      <AppMain :isShowCates="isShowCates"/>
    </el-main>
    <el-footer class="footer" height="auto">
      <div class="container-fixed">
        <el-row :gutter="110">
          <el-col v-for="linkItem in footerLinks" :key="linkItem.title" :span="6">
            <p class="footer-title">
              <svg-icon class="footer-icon" :class="'icon-' + linkItem.icon" :icon-class="linkItem.icon" />
              {{linkItem.title}}
            </p>
            <p v-for="link in linkItem.links" :key="link.title" class="footer-link">
              <a :href="link.url">
                {{link.title}}
              </a>
            </p>
            <el-button v-if="linkItem.icon == 'phone'" icon="el-icon-service" plain style="margin: 10px 25px" @click="openOLService">联系客服</el-button>
          </el-col>
        </el-row>
      </div>
    </el-footer>
  </el-container>
</template>

<script>

  import { AppMain } from './components'
  import { createNamespacedHelpers, mapState } from 'vuex'
  import config from '@/config'
  const { mapGetters: cartMapGetters } = createNamespacedHelpers('cart')
  const footerLinks = [
    ['phone', config.customerService.tel, [config.customerService.time]],
    ['help', '购物帮助', ['关于企业内购|#', '内购说明|#', '支付帮助|#']],
    ['shipping', '配送', ['配送运费|#', '自提说明|#']],
    ['peoples', '企业合作', ['申请⼊口|#']]
  ].map(item => ({
    icon: item[0],
    title: item[1],
    links: item[2].map(link => ({
      title: link.split('|')[0],
      url: link.split('|')[1]
    }))
  }));

  export default {
    name: 'MemberLayout',
    components: {
      AppMain
    },
    data() {
      return {
        footerLinks,
        keyword: '',
        logoUrl: config.siteLogo,
      }
    },
    computed: {
      ...cartMapGetters([
        'cartNum'
      ]),
      ...mapState('activity', {
        activityId: state => state.activityId
      }),
      isShowCates() {
        const notShowCate = ['/home']
        let isHide = false
        isHide = notShowCate.find(item => {
          return item == this.$route.path
        })

        if (isHide) {
          return false
        }

        return true
      }
    },
    watch: {
      $route() {
        this.showKeyword()
      }
    },
    created() {
      this.showKeyword()
    },
    methods: {
      handleSearch() {
        if (this.keyword != '') {
          this.$router.push({ name: 'product-search', query: {keyword: this.keyword} })
        }
      },
      updateActivity() {
        this.$store.dispatch('activity/setId', this.activityId)
      },
      showKeyword() {
        const query = this.$route.query
        if (query && query.keyword) {
          //console.log(1111)
          this.keyword = query.keyword
        } else {
          //console.log(2222)
          this.keyword = ''
        }
        //console.log(this.$route)
      },
      openOLService() {
        const userStorage = localStorage.getItem('user')
        if (userStorage) {
          const user = JSON.parse(userStorage)
          ysf('config', {
            uid:`internal-purchase|${user.id}`,
            name: user.name
          })
        }
        ysf.open()
      }
    },
    async mounted() {
      await this.updateActivity();
    }
  }
</script>
